import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Heart } from 'lucide-react';

const HeroEN = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-warm-beige to-cream overflow-hidden pt-32 md:pt-40 pb-24 md:pb-16">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(247, 243, 233, 0.75), rgba(247, 243, 233, 0.8)), url('https://i.imgur.com/g0cPIxY.jpg')`
        }}
      />
      
      {/* Floating Elements */}
      <motion.div
        className="absolute top-20 left-10 w-20 h-20 bg-olive-light/20 rounded-full blur-xl"
        animate={{ 
          x: [0, 30, 0],
          y: [0, -20, 0],
        }}
        transition={{ 
          duration: 6,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div
        className="absolute bottom-20 right-16 w-32 h-32 bg-accent-orange/20 rounded-full blur-xl"
        animate={{ 
          x: [0, -40, 0],
          y: [0, 30, 0],
        }}
        transition={{ 
          duration: 8,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />

      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-5xl mx-auto">
          {/* Main Headline */}
          <motion.h1
            className="text-5xl md:text-7xl lg:text-8xl font-bold text-charcoal mb-8 leading-tight font-heading"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
          >
            Give hope.
            <br />
            <span className="text-olive-green">Live solidarity.</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            className="text-xl md:text-2xl text-charcoal/80 mb-16 md:mb-12 max-w-3xl mx-auto leading-relaxed font-primary"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            We ensure that humanitarian aid reaches where it is most urgently needed. 
            Together, we can improve the lives of people in crisis areas like Gaza and give them new perspectives.
          </motion.p>

          {/* Call to Action Buttons */}
          <motion.div
            className="flex flex-col sm:flex-row gap-6 justify-center items-center"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.9 }}
          >
            <button
              onClick={() => scrollToSection('donate')}
              className="group bg-olive-green hover:bg-olive-dark text-white px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 shadow-2xl hover:shadow-olive-green/30 flex items-center space-x-3 min-w-[200px]"
            >
              <span>Donate now</span>
              <Heart className="w-5 h-5 group-hover:animate-pulse" />
            </button>
            
            <button
              onClick={() => scrollToSection('about')}
              className="group bg-transparent border-2 border-olive-green text-olive-green hover:bg-olive-green hover:text-white px-8 py-4 rounded-full font-bold text-lg transition-all transform hover:scale-105 flex items-center space-x-3 min-w-[200px]"
            >
              <span>Learn more</span>
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </button>
          </motion.div>
        </div>
      </div>


    </section>
  );
};

export default HeroEN;
